import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import "../styles/FoundersProgram.css";
import FoundersContact from "./FoundersContact";
import { FaArrowRight } from "react-icons/fa6";

const yourList = [
  {
    img: "images/reduced.png",
    title: "Reduced Costs:",
    desc: "We focus on cost recovery, not profit, to help you meet your budget goals.",
  },
  {
    img: "images/fasterDevelopment.png",
    title: "Faster Development:",
    desc: "Akscel automates repetitive tasks, significantly reducing development time.",
  },
  {
    img: "images/focus Business.png",
    title: "Focus on Your Business:",
    desc: "Free yourself from development headaches and concentrate on building your startup.",
  },
  {
    img: "images/retainOwnership.png",
    title: "Retain Ownership:",
    desc: "You get full ownership of your source code and intellectual property (IP).",
  },
  {
    img: "images/seamlessScaling.png",
    title: "Seamless Scaling:",
    desc: "Your MVP is built on a serverless cloud environment, enabling easy scaling as you grow.",
  },
  {
    img: "images/skipHassles.png",
    title: "Skip Hiring Hassles:",
    desc: "Build your MVP with Akscel and save on the expense of setting up a development team.",
  },
  {
    img: "images/expertGuidance.png",
    title: "Expert Guidance:",
    desc: "Benefit from our experienced team's knowledge and quality project management.",
  },
  {
    img: "images/continuousSupport.png",
    title: "Continuous Support:",
    desc: "Get access to our on-going support as you build your startup and deliver your product to customers.",
  },
];


const FoundersProgram = () => {
  const navigate = useNavigate();

  const section4Ref = useRef(null);

   const handleScrollToSec4 = () => {
     section4Ref.current?.scrollIntoView({ behavior: "smooth" });
   };

   const [activeIndex, setActiveIndex] = useState(null);

   const toggleAnswer = (index) => {
     setActiveIndex(activeIndex === index ? null : index);
   };

  
  const faqData = [
    {
      question: "What Kind of MVPs can be built with the Founders program?",
      answer:
        "The Founders Program is suited for a wide range of MVPs, particularly those focused on web applications. However, during the application process, we will discuss your specific idea to ensure a good fit for the program.",
    },
    {
      question: "What if I don't have a technical background?",
      answer:
        "No problem! The Founders Program is designed for founders with or without technical expertise. We will handle the development side, allowing you to focus on your business vision.",
    },
    {
      question: "How do I apply to the Founders program?",
      answer:
        'Simply click the "Join the Founders Program" button and fill out the application form. We will review your application and contact you to discuss your project further.',
    },
    {
      question: "What happens when I join the Founders program?",
      answer:
        "You will be contacted to assess your idea and the feasibility of launching an MVP through a web application. If it is okay, we will proceed to understand your requirements for MVP, prepare a scope of work document, discuss commercials, and proceed with development if all terms are agreed upon.",
    },
  ];

  
  
  return (
    <div className="F_section">
      <div className="F_section_one">
        <h6>Founders Program</h6>
        <h1>Fast Track Your MVP Launch in weeks.</h1>
        <p>
          Akscel automates development, getting your MVP to market faster than
          ever.
        </p>
        <button onClick={handleScrollToSec4}>
          Join Program
          <FaArrowRight className="sec8Carrow" />
        </button>
      </div>
      {/* section 2 */}
      <div className="F_sec_two">
        <motion.div
          className="F_sec_two"
          initial={{ opacity: 0, y: 100 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 2, ease: "easeOut" }}
          viewport={{ once: false, amount: 0.3 }}
        >
          <h2>Overcome Development Hurdles and Launch Your Startup Faster</h2>
          <p>
            Starting a business is tough, especially when it comes to
            development. Traditional methods can be expensive, time-consuming,
            and require a lot of technical expertise. The Founders Program
            tackles these challenges head-on. We utilize our unique Product
            called Akscel to help you get your MVP (Minimum Viable Product)
            built in weeks, not months. You do not need to be a tech expert to
            get your application ready for your customers. All that is required
            are your specifications and your application will be ready in the
            shortest possible time.
          </p>
        </motion.div>
      </div>

      <motion.div
        className="F_sec_three overflow-hidden"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: false, amount: 0.2 }}
      >
        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: false, amount: 0.3 }}
        >
          Why Choose Founders Program
        </motion.h1>

        <div className="F_sec_three_one">
          {yourList.map((item, index) => (
            <motion.section
              key={index}
              className="F_sec_three_one_one"
              initial={{
                opacity: 0,
                x: index % 2 === 0 ? -30 : 30,
                scale: 0.95,
              }}
              whileInView={{
                opacity: 1,
                x: 0,
                scale: 1,
              }}
              transition={{
                duration: 0.6,
                delay: 0.1 * index,
                ease: "easeInOut",
              }}
              viewport={{ once: false, amount: 0.3 }}
            >
              <img src={item.img} alt={item.title} />
              <h5>{item.title}</h5>
              <p>{item.desc}</p>
            </motion.section>
          ))}
        </div>
      </motion.div>

      <section className="Video_section_container">
        <video
          className="Video_section"
          src="https://arshil-website.s3.us-east-1.amazonaws.com/founders-program/ArshilVideo.mp4"
          controls
          autoPlay
          muted
          loop
        />
      </section>

      {/* Section 4 */}

      <motion.div
        className="F_sec_four"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: false, amount: 0.3 }}
      >
        <motion.h2
          initial={{ opacity: 0, x: 100 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: false }}
        >
          Who is the Founders Program For?
        </motion.h2>

        {[
          "Aspiring entrepreneurs without coding background or full fledged tech team",
          "Startups facing development time and budget constainst",
          "Businesses seeking a faster path to launching their MVP",
          "Founders who values code quality and maintainability",
        ].map((text, index) => (
          <motion.section
            key={index}
            className="F_sec_four_one"
            initial={{ opacity: 0, x: 100 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.2 * (index + 1) }}
            viewport={{ once: false, amount: 0.2 }}
          >
            <img src="images/Correct_icon.png" alt="" />
            <p>{text}</p>
          </motion.section>
        ))}
      </motion.div>
      {/* form Section  */}
      <div ref={section4Ref}></div>
      <FoundersContact />
      {/* Section 5 */}
      <div className="F_sec_five">
        <h1>Frequently Asked Questions (FAQs)</h1>
        <div className="Founder-container">
          {faqData.map((item, index) => (
            <div
              key={index}
              className={`Founder-item ${
                activeIndex === index ? "active" : ""
              }`}
            >
              <h6
                className="Founder-question"
                onClick={() => toggleAnswer(index)}
              >
                {item.question}
                <span className="Founder-icon">
                  {activeIndex === index ? "−" : "+"}
                </span>
              </h6>
              {activeIndex === index && (
                <p className="Founder-answer">{item.answer}</p>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FoundersProgram;
